import type { Middleware } from '@nuxt/types';
import {
  SALES_COMPENSATION_2022_PAGE,
  REDIRECT_PAGE,
  CONTENT_LOBBY_PAGE,
  LANDING_ALL_PAGE,
  COOKIE_NAME_REDIRECT_TO_ONBOARDING,
  SIGN_IN_MODAL,
  SEARCH_PAGE,
  JOB_OPPORTUNITY_PAGE,
  JOB_OPPORTUNITY_HASHID_PAGE,
  JOB_OPPORTUNITY_HASHID_AUTH_PAGE,
  JOB_OPPORTUNITY_HASHID_CONTACT_PAGE,
  PROFILE_SETTINGS_PAGE,
  PROFILE_SETTINGS_ACCOUNT_PAGE,
  PROFILE_SETTINGS_APPEARANCE_PAGE,
  PROFILE_SETTINGS_NOTIFICATIONS_PAGE,
  PROFILE_REFERRAL_PAGE,
} from '@/constants';
import { warRoomStates } from '~/components/partials/war-room/constants';

const AVAILABLE_PAGES_FOR_IN_ONBOARDING_STATE = [
  SALES_COMPENSATION_2022_PAGE.name,
  REDIRECT_PAGE.name,
  CONTENT_LOBBY_PAGE.name,
  LANDING_ALL_PAGE.name,
  SEARCH_PAGE.name,
  JOB_OPPORTUNITY_PAGE.name,
  JOB_OPPORTUNITY_HASHID_PAGE.name,
  JOB_OPPORTUNITY_HASHID_AUTH_PAGE.name,
  JOB_OPPORTUNITY_HASHID_CONTACT_PAGE.name,
  PROFILE_SETTINGS_PAGE.name,
  PROFILE_SETTINGS_ACCOUNT_PAGE.name,
  PROFILE_SETTINGS_APPEARANCE_PAGE.name,
  PROFILE_SETTINGS_NOTIFICATIONS_PAGE.name,
  PROFILE_REFERRAL_PAGE.name,
];

const redirectRules: Middleware = ({ app, route, $auth, redirect }) => {
  const shouldRedirectToOnboarding = Object.keys(route.query)?.some(key => key === 'onboarding');

  // all rules apply only for loggedIn users
  if (!$auth.loggedIn) {
    if (shouldRedirectToOnboarding) {
      app.$cookies.set(COOKIE_NAME_REDIRECT_TO_ONBOARDING, true);
      app.$utils.redirectWithQuery({ query: { dynamic_modal: SIGN_IN_MODAL, onboarding: undefined } });
    }

    return;
  }

  // in_onboarding
  if ($auth.user.warRoomState === warRoomStates.IN_ONBOARDING && route.name) {
    if (AVAILABLE_PAGES_FOR_IN_ONBOARDING_STATE.includes(route.name)) {
      return;
    }

    // if user trying to go somewhere else we should redirect to onboarding
    redirect(`${process.env.internalBaseUrl}/simplified-onboarding/`, route.query);
    return;
  }

  if (!route.name) {
    return;
  }

  // Redirect all users with ?onboarding=true or cookie to onboarding regardless of completion state
  if (
    shouldRedirectToOnboarding ||
    (app.$cookies.get(COOKIE_NAME_REDIRECT_TO_ONBOARDING) && !route.path.startsWith('/search'))
  ) {
    if (AVAILABLE_PAGES_FOR_IN_ONBOARDING_STATE.includes(route.name)) {
      return;
    }

    redirect(`${process.env.internalBaseUrl}/simplified-onboarding/`, route.query);
  }
};

export default redirectRules;
